// extracted by mini-css-extract-plugin
export default {"opportunity":"Opportunity_opportunity__DSrkk","main__container":"Opportunity_main__container__H0xsk"};